import React from 'react'
import request from 'superagent';
import {getColorStyle, timeoutRedirect} from './Util';
import {URL_COVID} from "../constants/Url";
import {COVID_19_HEALTH_HAZARD_SCORE, COVID_19_RESEARCH} from '../constants/Url'
import {Link} from "react-router-dom";
// import TagManager from 'react-gtm-module'
// import {getTagManagerArgs} from './Util';
export default class buyapp extends React.Component {

  render() {
    const TypeLink = (title, css) => {
      return <div className={`type ${css}`}>{title}</div>
    }

    return (<div>

      <div className=" lpwrap">
        <div className="wrap">
          <div className="head_nav">
            <Link to={{
                pathname: "/",
                state: {
                  referer: "/"
                }
              }}></Link>COVID-19 レポート</div>

          <div className="rad_field">

            <img src="/image/covid/phone.png" alt=""/>
            <div className="inwrap">
              <h1 className="text-center">The COVID-19 report is available to purchase<br/>
              through the GeneLife mobile application.</h1>

              <p>既にGenesis2.0をご利用いただいているお客様は、モバイルアプリ経由で、追加のCOVID-19のレポートをご購入ください。既にMyself2.0をご利用いただいているお客様は、モバイルアプリ経由で、COVID-19のレポートを含むGenesis2.0を割引価格にてご購入ください。</p>
              <div className="toapps">
                <div><a href="https://apps.apple.com/jp/app/genelife-3-0/id1453465159?ls=1" target="_blank"><img src="/image/covid/applestore.png" alt=""/></a></div>
                <div><a href="https://play.google.com/store/apps/details?id=jp.genelife" target="_blank"><img src="/image/covid/googleplay.png" alt=""/></a></div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>)
  }

}



// WEBPACK FOOTER //
// ./src/components/Buyapp.js